export function downloadDataExport(axios, exportType, params) {
    const requestParams = Object.assign({}, params, {exportType: exportType});
    return axios.post('web_export_data', {params: requestParams}, {responseType: 'blob'}).then(response => {
        const contentType = response.headers['content-type'];
        if (contentType == null || contentType.indexOf('text/csv') === -1) {
            throw new Error('Export response must be text/csv');
        }
        const contentDisposition = response.headers['content-disposition'];
        const fileNameMatch = /^attachment; filename="([^"]+)"$/.exec(contentDisposition || '');
        if (fileNameMatch == null) {
            throw new Error('Export response filename is missing');
        }

        const downloadUrl = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileNameMatch[1];
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    });
}
